import NavbarCompanyProfile from "@/components/NavBar/NavbarCompanyProfile";
import NavbarIntercomToggle from "@/components/NavBar/NavbarIntercomToggle";
import NavbarLanguageSelector from "@/components/NavBar/NavbarLanguageSelector";
import NavButton from "@/components/NavBar/NavButton";
import SideDrawer from "@/components/NavBar/SideDrawer";
import {useLogout} from "@/hooks/useLogout";
import {useIsAdmin} from "@/hooks/useUserHooks";
import useUserStore from "@/store/user";
import {useMemo, type FC} from "react";
import {useTranslation} from "react-i18next";
import {useMedia, useToggle} from "react-use";

const NavbarInfluencer: FC = () => {
  const {t} = useTranslation("navigation");
  const isAdmin = useIsAdmin();
  const influencerId = useUserStore(state => state.user.influencer_uuid);
  const isMobileView = useMedia("(max-width: 1024px)");
  const [isDrawerOpen, toggleDrawerOpen] = useToggle(false);
  const logout = useLogout();

  const influencersButton = useMemo(() => <NavButton to={`/influencers-list/`} text={t("influencers")} />, [t]);
  const campaignsButton = useMemo(() => <NavButton text={t("campaigns")} to="/campaigns/" />, [t]);
  const agenciesButton = useMemo(() => <NavButton text={t("customers")} to="/admins/customers/" />, [t]);

  return isMobileView ? (
    <div className="flex gap-1">
      <NavbarLanguageSelector />
      <SideDrawer isOpen={isDrawerOpen} toggleOpen={toggleDrawerOpen}>
        {isAdmin && agenciesButton}
        {influencersButton}
        {campaignsButton}
        {isAdmin && (
          <>
            <NavButton
              text={t("create_new_multi_account_user")}
              to="/admins/agency/create/"
              className="whitespace-normal"
            />
            <NavButton text={t("combine_accounts")} to="/admins/accounts/combine/" className="whitespace-normal" />
          </>
        )}
        <div className="bg-neutral-grey-light h-[1px] w-full" />
        <NavButton text={t("your_profile")} to={`/influencer/${influencerId}/`} />
        <NavButton text={t("logout")} onClick={() => logout()} />
      </SideDrawer>
    </div>
  ) : (
    <div className="flex h-full items-center gap-7 xl:gap-10">
      {isAdmin && agenciesButton}
      {influencersButton}
      {campaignsButton}
      <div className="flex items-center gap-5">
        <NavbarLanguageSelector />
        <NavbarIntercomToggle />
      </div>
      <NavbarCompanyProfile />
    </div>
  );
};

export default NavbarInfluencer;
